import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposContatos } from './tipos_contatos_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposContatosListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_CONTATOS, paginaPermissao: FUNCIONALIDADES.TIPOS_CONTATOS, rota: ROUTES.TIPOS_CONTATOS, fetchData: function (str, _filter, pag) { return getTiposContatos(str, pag); }, columns: COLUNAS }));
}
export default TiposContatosListar;
